<div class="flex flex-col gap-6">
  <div *ngIf="backLabel" class="flex justify-start" data-testid="access-back">
    <ui-button-text
      icon-preffix="arrow-left"
      text-color="neutral-700"
      hover-text-color="neutral-900"
      font-weight="bold"
      size="sm"
      [responsive]="false"
      (clicked)="back.emit()"
      >{{ backLabel }}</ui-button-text
    >
  </div>

  <div class="flex flex-col items-center gap-6 text-center">
    <div
      class="flex items-center justify-center rounded-full w-16 h-16 lg:w-20 lg:h-20"
      [ngClass]="circleClass"
      data-testid="access-icon"
    >
      <ui-icon
        set="uds"
        size="40"
        mobile-size="32"
        [iconName]="icon"
        [fill]="iconFill"
      ></ui-icon>
    </div>

    <div class="flex flex-col gap-2">
      <ui-headline
        class="block !text-center"
        type="h28"
        mobile-type="h24"
        font-family="display"
        text-color="neutral-900"
        font-weight="regular"
        [content]="heading"
        data-testid="access-title"
      ></ui-headline>
      <ui-paragraph
        *ngIf="subtitle"
        class="block !text-center"
        type="p16"
        mobile-type="p16"
        text-color="neutral-400"
        font-weight="regular"
        [content]="subtitle"
        data-testid="access-subtitle"
      ></ui-paragraph>
    </div>
  </div>
</div>
